// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="dialogHeader" id="dialogHeader">Select Property</h1>
        </div>
        <div class="hoa-dialog__main">
            <div class="scrollable-dialog-container" *ngIf="data.properties.length > 0">
                <div class="u-display-table-row" *ngFor="let property of data.properties">
                    <div class="property-selector-nickname" tid="scheduleNickname">
                        {{property.nickname}}
                    </div>
                    <div class="property-selector-select">
                        <button tid="select"
                                id="select"
                                class="Button Button--blue"
                                (click)="navigateToPropertyPayments(property)">
                            Select
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="okButton" id="okButton" class="Button Button--blue Button--minWidth130" (click)="closeThisDialog('OK')">Cancel</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;